import { render, staticRenderFns } from "./AddHostingDetailedInfo.vue?vue&type=template&id=08b1c2fc"
import script from "./AddHostingDetailedInfo.vue?vue&type=script&lang=js"
export * from "./AddHostingDetailedInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports